import React, { FC } from 'react';
import styled from 'styled-components';

import { NgAssetUploadInput, NgButton} from '../../../../../../../components';

interface TemplateOutputTypeHandlerProps {
  type: { label: string; value: string } | null;
  isLoading?: boolean;
  uploadFolderId: number;
  onEditMicrosite: () => void;
  templateData?: any;
  onUpload?: (data: any) => void;
}

const StyledTemplateOutputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

const StyledMicrositeTemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const TemplateOutputTypeHandler: FC<TemplateOutputTypeHandlerProps> = ({
  type,
  onUpload,
  isLoading,
  templateData,
  uploadFolderId,
  onEditMicrosite,
}) => {
  const { Asset: documentAsset, Template: htmlTemplate } = templateData || {};

  if (!type?.value) {
    return <p>Please select an output type!</p>;
  }

  if (type?.value !== 'html') {
    return (
      <StyledTemplateOutputContainer>
        <label>Upload Template</label>

        <NgAssetUploadInput
          asset={documentAsset}
          downloadTitle="Download Template File"  
          uploadFolderId={uploadFolderId}
          acceptedFileTypes={`.${type?.value}`}
          isLoading={isLoading}
          onUpload={onUpload}
        />
      </StyledTemplateOutputContainer>
    );
  }

  return (
    <StyledMicrositeTemplateContainer>
      <label>Microsite Template </label>
      <NgButton onClick={onEditMicrosite}>{htmlTemplate ? 'Edit' : 'Create'} Microsite Template</NgButton>
    </StyledMicrositeTemplateContainer>
  );
};

//endregion
